import workflowRepository from "@/respsitory/workflowRepository";
import {useQuery} from "@tanstack/react-query";
import {LLMVendorModelList} from "@/model/Workflow";
import {AxiosError} from "axios";

const getData = async () => {
    try {
        const {data} = await workflowRepository.read_llm_vendor();
        return data.result;
    } catch (e) {
        throw e;
    }
}

const useLlmModels = () => {
    return useQuery<LLMVendorModelList, AxiosError>({
        queryKey: ["llm_vendor_models"],
        queryFn: async () => await getData(),
        retry: false,
        suspense: false
    })
}

export default useLlmModels;